// extracted by mini-css-extract-plugin
export default {"setCreateFormItem":"CreateEditModal_setCreateFormItem__PHFy6"};